// ----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
// ----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { AddressDto, AOrder, BasketDto, CarriageOptionDto, ValidationDto, MultiShipDto, OrderAddressSaveDto, OrderSaveResultDto, OrderLineAddResultDto, AddToBasketDto, OrderLineQuantityResultDto, VoucherResultDto, OrderLineAddressResultDto, OrderLineAddressSaveDto, OrderLinePersonResultDto, OrderLinePersonSaveDto, Address } from "../../types";
import type { UseApiFetchOptions, UseApiFetchResponse } from "../../composables/useApiFetch";
import type { NitroFetchOptions } from "nitropack";
import type { Ref, MaybeRef } from "vue";
import {
    $apiFetch,
    computed,
    unref,
    useApiFetch,
    useFetchDependencies
} from "#imports";

export function useBasketResource () {

    /**
     * Stream basket data to the client
     * @param oldBasketId (optional) The old basket ID (optional)
     * @param newBasketId (optional) The new basket ID (optional)
     */
    function getBasketStream(
        oldBasketId?: MaybeRef<string | null | undefined>,
        newBasketId?: MaybeRef<string | null | undefined>
    ) : UseApiFetchResponse<void> {
        const computedUrl = computed( () => {
          let url_ = "/api/Basket/stream?";

        const oldBasketIdUnref = unref( oldBasketId );
        if (oldBasketIdUnref !== undefined && oldBasketIdUnref !== null)
            url_ += "oldBasketId=" + encodeURIComponent("" + oldBasketIdUnref) + "&";
        const newBasketIdUnref = unref( newBasketId );
        if (newBasketIdUnref !== undefined && newBasketIdUnref !== null)
            url_ += "newBasketId=" + encodeURIComponent("" + newBasketIdUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<void> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<void>( computedUrl, options_ );
    }

    /**
     * Load everything to do with the basket in one go. This is to reduce network trafic and API calls.
    The main use is when loading the basket page or checkout for the first time. It is not called
    automatically
     * @param inBasket (optional) True if we are validating from within a basket. In this case we
                need to ignore carriage validation
     * @return Full basket data (basket, carriage and validation)
     */
    function fullBasket(
        inBasket?: MaybeRef<boolean | undefined>
    ) : UseApiFetchResponse<BasketDto> {
        const computedUrl = computed( () => {
          let url_ = "/api/Basket/full?";

        const inBasketUnref = unref( inBasket );
        if (inBasketUnref === null)
            throw new Error("The parameter 'inBasket' cannot be null.");
        else if (inBasketUnref !== undefined)
            url_ += "inBasket=" + encodeURIComponent("" + inBasketUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<BasketDto> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<BasketDto>( computedUrl, options_ );
    }

    /**
     * Load multi ship configuration (we have to be logged in for this to work)
     * @return Multi-ship configuration
     */
    function getMultiShipConfig(
        
    ) : UseApiFetchResponse<MultiShipDto> {
        const computedUrl = computed( () => {
          let url_ = "/api/Basket/multiship";

        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<MultiShipDto> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<MultiShipDto>( computedUrl, options_ );
    }


    /**
     * Retrieves the contents of the basket.
     * @param dontPublish (optional) Prevent the refreshed basket being published to other subscriptions
     * @return An asynchronous task that returns an ActionResult containing a AOrder or null.
     */
    function getBasket(
        dontPublish?: MaybeRef<boolean | null | undefined>
    ) : UseApiFetchResponse<AOrder> {
        const computedUrl = computed( () => {
          let url_ = "/api/Basket?";

        const dontPublishUnref = unref( dontPublish );
        if (dontPublishUnref !== undefined && dontPublishUnref !== null)
            url_ += "dontPublish=" + encodeURIComponent("" + dontPublishUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<AOrder> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<AOrder>( computedUrl, options_ );
    }

    /**
     * Check to see if we need to get the basket. If the ID supplied
    does not match the ID in the cookie then the basket data
    will be refreshed
     * @param basketId (optional) The basket ID to check
     * @return Basket data or null
     */
    function checkBasket(
        basketId?: MaybeRef<string | null | undefined>
    ) : UseApiFetchResponse<AOrder> {
        const computedUrl = computed( () => {
          let url_ = "/api/Basket/check?";

        const basketIdUnref = unref( basketId );
        if (basketIdUnref !== undefined && basketIdUnref !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketIdUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<AOrder> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<AOrder>( computedUrl, options_ );
    }


    /**
     * Validates the current basket.
     * @param inBasket (optional) True if we are validating from within the basket. In this case we
                need to ignore carriage validation
     * @return An ActionResult containing the validation data, or BadRequest if no order is found.
     */
    function validate(
        inBasket?: MaybeRef<boolean | undefined>
    ) : UseApiFetchResponse<ValidationDto> {
        const computedUrl = computed( () => {
          let url_ = "/api/Basket/validate?";

        const inBasketUnref = unref( inBasket );
        if (inBasketUnref === null)
            throw new Error("The parameter 'inBasket' cannot be null.");
        else if (inBasketUnref !== undefined)
            url_ += "inBasket=" + encodeURIComponent("" + inBasketUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<ValidationDto> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<ValidationDto>( computedUrl, options_ );
    }





    /**
     * List carriage that is suitable for the current order
     * @return A list of carriage items
     */
    function listCarriage(
        
    ) : UseApiFetchResponse<CarriageOptionDto[]> {
        const computedUrl = computed( () => {
          let url_ = "/api/Basket/carriage";

        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<CarriageOptionDto[]> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<CarriageOptionDto[]>( computedUrl, options_ );
    }





    /**
     * List addresses that can be selected as alternate addresses for the current account
     * @param type (optional) The type of addresses to return (I, B) or D
     * @return A list of addresses
     */
    function listAccountAddresses(
        type?: MaybeRef<string | undefined>
    ) : UseApiFetchResponse<AddressDto[]> {
        const computedUrl = computed( () => {
          let url_ = "/api/Basket/addresses?";

        const typeUnref = unref( type );
        if (typeUnref === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (typeUnref !== undefined)
            url_ += "type=" + encodeURIComponent("" + typeUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<AddressDto[]> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<AddressDto[]>( computedUrl, options_ );
    }

    return {
        getBasketStream,
        fullBasket,
        getMultiShipConfig,
        getBasket,
        checkBasket,
        validate,
        listCarriage,
        listAccountAddresses,
    }
}


export function $basketResource () {

    const dependencies_ = useFetchDependencies();

    /**
     * Stream basket data to the client
     * @param oldBasketId (optional) The old basket ID (optional)
     * @param newBasketId (optional) The new basket ID (optional)
     */
    function getBasketStream(
        oldBasketId?: string | null | undefined,
        newBasketId?: string | null | undefined
    ) {
        let url_ = "/api/Basket/stream?";

        const oldBasketIdUnref = unref( oldBasketId );
        if (oldBasketIdUnref !== undefined && oldBasketIdUnref !== null)
            url_ += "oldBasketId=" + encodeURIComponent("" + oldBasketIdUnref) + "&";
        const newBasketIdUnref = unref( newBasketId );
        if (newBasketIdUnref !== undefined && newBasketIdUnref !== null)
            url_ += "newBasketId=" + encodeURIComponent("" + newBasketIdUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<void>( url_, options_, dependencies_ );
    }

    /**
     * Load everything to do with the basket in one go. This is to reduce network trafic and API calls.
    The main use is when loading the basket page or checkout for the first time. It is not called
    automatically
     * @param inBasket (optional) True if we are validating from within a basket. In this case we
                need to ignore carriage validation
     * @return Full basket data (basket, carriage and validation)
     */
    function fullBasket(
        inBasket?: boolean | undefined
    ) {
        let url_ = "/api/Basket/full?";

        const inBasketUnref = unref( inBasket );
        if (inBasketUnref === null)
            throw new Error("The parameter 'inBasket' cannot be null.");
        else if (inBasketUnref !== undefined)
            url_ += "inBasket=" + encodeURIComponent("" + inBasketUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<BasketDto>( url_, options_, dependencies_ );
    }

    /**
     * Load multi ship configuration (we have to be logged in for this to work)
     * @return Multi-ship configuration
     */
    function getMultiShipConfig(
        
    ) {
        let url_ = "/api/Basket/multiship";

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<MultiShipDto>( url_, options_, dependencies_ );
    }

    /**
     * Detach the basket from this session by clearing the cookie
     * @return True if successful
     */
    function detachBasket(
        
    ) {
        let url_ = "/api/Basket/detatch";

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "POST",
        };

        return $apiFetch<boolean>( url_, options_, dependencies_ );
    }

    /**
     * Retrieves the contents of the basket.
     * @param dontPublish (optional) Prevent the refreshed basket being published to other subscriptions
     * @return An asynchronous task that returns an ActionResult containing a AOrder or null.
     */
    function getBasket(
        dontPublish?: boolean | null | undefined
    ) {
        let url_ = "/api/Basket?";

        const dontPublishUnref = unref( dontPublish );
        if (dontPublishUnref !== undefined && dontPublishUnref !== null)
            url_ += "dontPublish=" + encodeURIComponent("" + dontPublishUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<AOrder>( url_, options_, dependencies_ );
    }

    /**
     * Check to see if we need to get the basket. If the ID supplied
    does not match the ID in the cookie then the basket data
    will be refreshed
     * @param basketId (optional) The basket ID to check
     * @return Basket data or null
     */
    function checkBasket(
        basketId?: string | null | undefined
    ) {
        let url_ = "/api/Basket/check?";

        const basketIdUnref = unref( basketId );
        if (basketIdUnref !== undefined && basketIdUnref !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketIdUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<AOrder>( url_, options_, dependencies_ );
    }

    /**
     * Removes all order lines from the current basket.
     * @return Whether any order lines were removed or not.
     */
    function clearBasket(
        
    ) {
        let url_ = "/api/Basket/clear";

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "POST",
        };

        return $apiFetch<boolean>( url_, options_, dependencies_ );
    }

    /**
     * Abandon the current basket.
     * @return Whether any order lines were removed or not.
     */
    function abandonBasket(
        
    ) {
        let url_ = "/api/Basket/abandon";

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "POST",
        };

        return $apiFetch<boolean>( url_, options_, dependencies_ );
    }

    /**
     * Validates the current basket.
     * @param inBasket (optional) True if we are validating from within the basket. In this case we
                need to ignore carriage validation
     * @return An ActionResult containing the validation data, or BadRequest if no order is found.
     */
    function validate(
        inBasket?: boolean | undefined
    ) {
        let url_ = "/api/Basket/validate?";

        const inBasketUnref = unref( inBasket );
        if (inBasketUnref === null)
            throw new Error("The parameter 'inBasket' cannot be null.");
        else if (inBasketUnref !== undefined)
            url_ += "inBasket=" + encodeURIComponent("" + inBasketUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<ValidationDto>( url_, options_, dependencies_ );
    }

    /**
     * Sets an address and person data against the current basket.
     * @param addressSaveDto (optional) The address and person data to save
     * @return Updated address and person data
     */
    function setAddress(
        addressSaveDto?: OrderAddressSaveDto | undefined
    ) {
        let url_ = "/api/Basket/address";

        url_ = url_.replace(/[?&]$/, "");

              const content_ = addressSaveDto;

        let options_: NitroFetchOptions<string> = {
            body: content_,
            method: "POST",
        };

        return $apiFetch<OrderAddressSaveDto>( url_, options_, dependencies_ );
    }

    /**
     * Adds items to the basket.
     * @param addToBasketDtos (optional) An enumerable collection of AddToBasketDto objects.
     * @return An asynchronous task that returns a List`1 of OrderLineAddResultDto or null.
     */
    function addToBasket(
        addToBasketDtos?: AddToBasketDto[] | undefined
    ) {
        let url_ = "/api/Basket/lines";

        url_ = url_.replace(/[?&]$/, "");

              const content_ = addToBasketDtos;

        let options_: NitroFetchOptions<string> = {
            body: content_,
            method: "POST",
        };

        return $apiFetch<OrderSaveResultDto>( url_, options_, dependencies_ );
    }

    /**
     * Remove items from the basket.
     * @param lineIds (optional) The IDs to remove.
     * @return An asynchronous task that returns an ActionResult containing a Boolean.
     */
    function removeFromBasket(
        lineIds?: string[] | undefined
    ) {
        let url_ = "/api/Basket/lines/remove?";

        const lineIdsUnref = unref( lineIds );
        if (lineIdsUnref === null)
            throw new Error("The parameter 'lineIds' cannot be null.");
        else if (lineIdsUnref !== undefined)
            lineIdsUnref && lineIdsUnref.forEach(item => { url_ += "lineIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "POST",
        };

        return $apiFetch<OrderSaveResultDto>( url_, options_, dependencies_ );
    }

    /**
     * Updates the quantity of a specified order line in the current basket.
     * @param lineId (optional) The unique identifier of the order line to update.
     * @param newQuantity (optional) The new quantity for the specified order line.
     * @return An asynchronous task that returns the result of the quantity update operation.
     */
    function updateQuantity(
        lineId?: string | undefined,
        newQuantity?: number | undefined
    ) {
        let url_ = "/api/Basket/lines/quantity?";

        const lineIdUnref = unref( lineId );
        if (lineIdUnref === null)
            throw new Error("The parameter 'lineId' cannot be null.");
        else if (lineIdUnref !== undefined)
            url_ += "lineId=" + encodeURIComponent("" + lineIdUnref) + "&";
        const newQuantityUnref = unref( newQuantity );
        if (newQuantityUnref === null)
            throw new Error("The parameter 'newQuantity' cannot be null.");
        else if (newQuantityUnref !== undefined)
            url_ += "newQuantity=" + encodeURIComponent("" + newQuantityUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "POST",
        };

        return $apiFetch<OrderLineQuantityResultDto>( url_, options_, dependencies_ );
    }

    /**
     * Apply a voucher to the basket
     * @param voucherCode (optional) The voucher to apply
     * @param removeExisting (optional) Should we remove existing vouchers
     * @return Details of the voucher that was added
     */
    function applyVoucher(
        voucherCode?: string | undefined,
        removeExisting?: boolean | undefined
    ) {
        let url_ = "/api/Basket/voucher?";

        const voucherCodeUnref = unref( voucherCode );
        if (voucherCodeUnref === null)
            throw new Error("The parameter 'voucherCode' cannot be null.");
        else if (voucherCodeUnref !== undefined)
            url_ += "voucherCode=" + encodeURIComponent("" + voucherCodeUnref) + "&";
        const removeExistingUnref = unref( removeExisting );
        if (removeExistingUnref === null)
            throw new Error("The parameter 'removeExisting' cannot be null.");
        else if (removeExistingUnref !== undefined)
            url_ += "removeExisting=" + encodeURIComponent("" + removeExistingUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "POST",
        };

        return $apiFetch<VoucherResultDto>( url_, options_, dependencies_ );
    }

    /**
     * Remove a voucher from the basket
     * @param voucherCode (optional) The voucher code to remove
     * @return Was the removal successful
     */
    function removeVoucher(
        voucherCode?: string | undefined
    ) {
        let url_ = "/api/Basket/voucher/remove?";

        const voucherCodeUnref = unref( voucherCode );
        if (voucherCodeUnref === null)
            throw new Error("The parameter 'voucherCode' cannot be null.");
        else if (voucherCodeUnref !== undefined)
            url_ += "voucherCode=" + encodeURIComponent("" + voucherCodeUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "POST",
        };

        return $apiFetch<boolean>( url_, options_, dependencies_ );
    }

    /**
     * List carriage that is suitable for the current order
     * @return A list of carriage items
     */
    function listCarriage(
        
    ) {
        let url_ = "/api/Basket/carriage";

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<CarriageOptionDto[]>( url_, options_, dependencies_ );
    }

    /**
     * Apply a carriage option to an order
     * @param carriageId (optional) The carriage ID to apply
     * @return True if successful
     */
    function applyCarriage(
        carriageId?: number | undefined
    ) {
        let url_ = "/api/Basket/carriage?";

        const carriageIdUnref = unref( carriageId );
        if (carriageIdUnref === null)
            throw new Error("The parameter 'carriageId' cannot be null.");
        else if (carriageIdUnref !== undefined)
            url_ += "carriageId=" + encodeURIComponent("" + carriageIdUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "POST",
        };

        return $apiFetch<boolean>( url_, options_, dependencies_ );
    }

    /**
     * Set the default delivery address and org on all lines of the order that do not current have
    both a delivery address ID and a delivery organisation ID
     * @param orgId (optional) The ID of the default Organisation
     * @param addressId (optional) The ID of the default address
     * @return True if the updates all went successfully
     */
    function setDefaultDelivery(
        orgId?: string | null | undefined,
        addressId?: string | null | undefined
    ) {
        let url_ = "/api/Basket/lines/defaultdelivery?";

        const orgIdUnref = unref( orgId );
        if (orgIdUnref !== undefined && orgIdUnref !== null)
            url_ += "orgId=" + encodeURIComponent("" + orgIdUnref) + "&";
        const addressIdUnref = unref( addressId );
        if (addressIdUnref !== undefined && addressIdUnref !== null)
            url_ += "addressId=" + encodeURIComponent("" + addressIdUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "POST",
        };

        return $apiFetch<boolean>( url_, options_, dependencies_ );
    }

    /**
     * Blank out the delivery details for all lines od the order
     * @return True if the update is successful
     */
    function clearDelivery(
        
    ) {
        let url_ = "/api/Basket/lines/cleardelivery";

        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "POST",
        };

        return $apiFetch<boolean>( url_, options_, dependencies_ );
    }

    /**
     * Update the address details on an order line
     * @param lineAddress Details of the line address to update
     * @return Information about the line that was updated
     */
    function updateLineDelivery(
        lineAddress: OrderLineAddressSaveDto
    ) {
        let url_ = "/api/Basket/lines/delivery";

        url_ = url_.replace(/[?&]$/, "");

              const content_ = lineAddress;

        let options_: NitroFetchOptions<string> = {
            body: content_,
            method: "POST",
        };

        return $apiFetch<OrderLineAddressResultDto>( url_, options_, dependencies_ );
    }

    /**
     * Update the delivery person against this order line
     * @param linePerson Person details to save against an order line
     * @return The ID of the person we saved against the order line
     */
    function updateLinePerson(
        linePerson: OrderLinePersonSaveDto
    ) {
        let url_ = "/api/Basket/lines/deliveryperson";

        url_ = url_.replace(/[?&]$/, "");

              const content_ = linePerson;

        let options_: NitroFetchOptions<string> = {
            body: content_,
            method: "POST",
        };

        return $apiFetch<OrderLinePersonResultDto>( url_, options_, dependencies_ );
    }

    /**
     * Remove the delivery person against this order line
     * @param lineId (optional) The ID of the line to remove the person from
     * @return The ID of the line that was updated
     */
    function removeLinePerson(
        lineId?: string | undefined
    ) {
        let url_ = "/api/Basket/lines/removedeliveryperson?";

        const lineIdUnref = unref( lineId );
        if (lineIdUnref === null)
            throw new Error("The parameter 'lineId' cannot be null.");
        else if (lineIdUnref !== undefined)
            url_ += "lineId=" + encodeURIComponent("" + lineIdUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "POST",
        };

        return $apiFetch<string | null>( url_, options_, dependencies_ );
    }

    /**
     * List addresses that can be selected as alternate addresses for the current account
     * @param type (optional) The type of addresses to return (I, B) or D
     * @return A list of addresses
     */
    function listAccountAddresses(
        type?: string | undefined
    ) {
        let url_ = "/api/Basket/addresses?";

        const typeUnref = unref( type );
        if (typeUnref === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (typeUnref !== undefined)
            url_ += "type=" + encodeURIComponent("" + typeUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<AddressDto[]>( url_, options_, dependencies_ );
    }

    /**
     * Save the address as a SOP address against the current web account
     * @param address The address to save
     * @return The ID of the newly saved address
     */
    function saveAccountAddress(
        address: AddressDto
    ) {
        let url_ = "/api/Basket/addresses";

        url_ = url_.replace(/[?&]$/, "");

              const content_ = address;

        let options_: NitroFetchOptions<string> = {
            body: content_,
            method: "POST",
        };

        return $apiFetch<string | null>( url_, options_, dependencies_ );
    }

    return {
        getBasketStream,
        fullBasket,
        getMultiShipConfig,
        detachBasket,
        getBasket,
        checkBasket,
        clearBasket,
        abandonBasket,
        validate,
        setAddress,
        addToBasket,
        removeFromBasket,
        updateQuantity,
        applyVoucher,
        removeVoucher,
        listCarriage,
        applyCarriage,
        setDefaultDelivery,
        clearDelivery,
        updateLineDelivery,
        updateLinePerson,
        removeLinePerson,
        listAccountAddresses,
        saveAccountAddress,
    }
}